export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  REFETCH_CONVERSATIONS: 'REFETCH_CONVERSATIONS',
  FOCUS_WIDGET_INPUT: 'FOCUS_WIDGET_INPUT',
  FETCH_CONVERSATION_STATS: 'FETCH_CONVERSATION_STATS',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  ADD_CANNED_RESPONSE_MODAL: 'addCannedResponseModal',
  INSERT_INTO_NORMAL_EDITOR: 'insertIntoNormalEditor',
  ENGAGEMENT_VOICE_INCOMING_CALL: 'ENGAGEMENT_VOICE_INCOMING_CALL',
};
